import axios from "axios";

var getOrganizationsAndGroups = function getOrganizationsAndGroups() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return axios.get("/organizations?include=groups&page=" + page);
};

var storeOrganization = function storeOrganization(request) {
  return axios.post("/organizations", request);
};

var getOrganization = function getOrganization(organizationId) {
  return axios.get("/organizations/".concat(organizationId));
};

var updateOrganization = function updateOrganization(organizationId, request) {
  return axios.put("/organizations/".concat(organizationId), request);
};

var deleteOrganization = function deleteOrganization(organizationId) {
  return axios.delete("/organizations/".concat(organizationId));
};

export { getOrganizationsAndGroups, storeOrganization, getOrganization, updateOrganization, deleteOrganization };